module.exports = __webpack_public_path__ + "static/img/dq7.c32a052.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/dq7.png
// module id = Ckub
// module chunks = 0